'use client';
import { JumboCard } from 'themes/jumbo/@jumbo/components';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { Grid2 as Grid, Typography, Button } from '@mui/material';
import { Chart, ChartLegend } from './components/Chart';
import { Link } from 'react-router-dom';
import './style.css';
import { useSelector } from 'react-redux';
import { trackEvent } from "components/Tracking";

const ProcessingTimeCard = () => {  
  const { limit_processtime, usageData } = useSelector((state: any) => state.auth.data);
  return (
    <JumboCard contentWrapper contentSx={{ p: 3 }}>
      <Grid container spacing={3.75} className="mainGrid">
        <Grid  size={{ xs:1, sm:1, md:4, lg:4, xl:4 }}>
              <Div sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Div sx={{ flex: 1 }} className='blockTitle'>
                  <Typography color={'text.primary'} variant={'h6'} mb={0}>
                    Monthly Processing Time
                  </Typography>
                </Div>
                <Div sx={{ alignContent: 'center' }}>
                   <Div sx={{ display: 'flex', gap: '4px', flexDirection: 'row', alignItems:'center'}} >
                    <Typography color={'text.primary'} variant={'h2'} mb={-0.5}>
                      {usageData?.hours || 0}
                    </Typography>
                  
                    <Typography color={'text.secondary'} variant={'h6'} mb={-1}>
                      { ` / ${limit_processtime}` }
                    </Typography>
                  </Div>
                  
                  <Typography color={'text.secondary'} variant={'h5'} mb={0}>
                    hours
                  </Typography>
                </Div>
              </Div>
        </Grid>
        <Grid  size={{ xs:1, sm:1, md:4, lg:4, xl:4 }}>
              <Div sx={{ display: 'flex', alignItems: 'center', height: '70px' }}>
                <Chart used={usageData?.hours || 0} />
              </Div>
        </Grid>
        <Grid  size={{ xs:1, sm:1, md:4, lg:4, xl:4 }}>
              <Div sx={{ display: 'flex', height: '100%', flexDirection: 'column' }} className='xsReverse'>
                <Div sx={{flex: 1, textAlign: 'right' }}>
                  <Button
                    size={'small'}
                    variant={'outlined'}
                    component={Link} 
                    to="/profile"
                    style={{height: '25px', minWidth: 'auto', display: 'none'}}
                    onClick={(ev: any) => {
                        trackEvent("Dashboard", "Processing", "Manage")
                    }}
                  >
                    Manage
                  </Button>
                </Div>
                <Div sx={{ }}>
                  <ChartLegend />
                </Div>
              </Div>
        </Grid>
      </Grid>
    </JumboCard>
  );
};

export { ProcessingTimeCard };
